import React, { useEffect, useState } from "react";
import './MainPage.css'
import {useNavigate } from "react-router-dom";
import SideBar from "./SideBar/SideBar";
import Header from "./Header/Header";
import { faEye, faFilePen, faRightFromBracket, faGauge,faThList } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { UserOutlined } from '@ant-design/icons';

function MainPage(props) {
    const Navigate = useNavigate()
    const UserInfo = useState(JSON.parse(sessionStorage.getItem("UserInfo")))
    const [ActivePage, setActivePage] = useState("PermitBasicPage")
    
    useEffect(() => {
        if (sessionStorage.length === 0) {
            Navigate("/")
        }
    }, [])

    function toggleClass(targetElement, addedClass) {
        if (targetElement.classList.contains(addedClass)) {
            targetElement.classList.remove(addedClass);
        }
        else {
            targetElement.classList.add(addedClass);
        }
    };

    function toggleClassRemove(targetElement, addedClass) {
        if (targetElement.classList.contains(addedClass)) {
            targetElement.classList.remove(addedClass);
        }
    }

    const Logout = () => {
        toggleClassRemove(document.querySelector('.menu'), 'menu--open')
        setActivePage("")
        Navigate("/")
        sessionStorage.clear()
        window.location.reload(false);
    }

    const onSelectPage = (Pages) => {
        toggleClassRemove(document.querySelector('.menu'), 'menu--open')
        setActivePage(Pages)
        Navigate('/' + Pages)
    }

    return (
        <div className="MainClass" >
            <main className="container">
                <SideBar UserInfo={UserInfo} ActivePage={ActivePage} setActivePage={setActivePage} />
                <Header UserInfo={UserInfo} />
                <div className="dashboard" onClick={() => toggleClassRemove(document.querySelector('.menu'), 'menu--open')}>
                    {props.children}
                </div>
                <div className="MobileMenu">
                    <menu className="menu" >
                        <ul>
                            <div className="ProfileCard">
                            <UserOutlined style={{ fontSize: '20px', color: 'white' }} />
                                <li>{UserInfo[0]?.employeeName}</li>
                                <li>{UserInfo[0]?.employeeId}</li>
                                <li>{UserInfo[0]?.divisionName}</li>
                            </div>
                                <li onClick={() => onSelectPage("")} className={ActivePage === "Dashboard" ? "SideMenuButton_active" : "SideMenuButton"}>
                                    <FontAwesomeIcon icon={faGauge} style={{ marginRight: '10px', marginLeft: '10px' }} />
                                    <span className="desc" >Dashboard</span>
                                </li>
                                <li onClick={() => onSelectPage("BasicPermit")} className={ActivePage === "FormPage" ? "SideMenuButton_active" : "SideMenuButton"}>
                                    <FontAwesomeIcon icon={faFilePen} style={{ marginRight: '10px', marginLeft: '10px' }} />
                                    <span className="desc" >Request View</span>
                                </li>
                             
                            {UserInfo[0]?.isApprover === true &&
                                <li onClick={() => onSelectPage("ViewApprovalPage")} className={ActivePage === "ViewApprovalPage" ? "SideMenuButton_active" : "SideMenuButton"}>
                                    <FontAwesomeIcon icon={faEye} style={{ marginRight: '10px', marginLeft: '10px' }} />
                                    <span className="desc" >Approval List</span>
                                </li>}
                                {UserInfo[0]?.isExtensionApprover === true &&
                                <li onClick={() => onSelectPage("ExtensionApprovalPage")} className={ActivePage === "ExtensionApprovalPage" ? "SideMenuButton_active" : "SideMenuButton"}>
                                    <FontAwesomeIcon icon={faThList} style={{ marginRight: '10px', marginLeft: '10px' }} />
                                    <span className="desc" >Extension List</span>
                                </li>}
                            <li onClick={() => Logout()} className={ActivePage === "Logout" ? "SideMenuButton_active" : "SideMenuButton"}>
                                <FontAwesomeIcon icon={faRightFromBracket} style={{ marginRight: '10px', marginLeft: '10px' }} />
                                <span className="desc" >Logout</span>
                            </li>
                        </ul>
                    </menu>
                    <nav onClick={() => toggleClass(document.querySelector('.menu'), 'menu--open')} className="menu-btn">
                        <ul>
                            <li></li>
                            <li></li>
                            <li></li>
                        </ul>
                    </nav>
                </div>
            </main>
        </div>
    )
}
export default MainPage;